import api from "./api";

export default {
  mixins: [ api ],
  methods: {
    async getRegisters(data) {
      let params = this.makeSearchParams(data);

      if (data.start_date) {
        const serverDate = this.getDateToServer(data.start_date).toISOString();
        params.set("start", serverDate);
      }

      if (data.end_date) {
        const serverDate = this.getDateToServer(data.end_date).toISOString();
        params.set("end", serverDate);
      }

      if (data.executor_id) {
        params.set("user_id", data.executor_id);
      }

      return await this.get(`register?${params.toString()}`);
    },
    async getRegisterTotals(data) {
      let params = this.makeSearchParams(data);

      if (data.start_date) {
        const serverDate = this.getDateToServer(data.start_date).toISOString();
        params.set("start", serverDate);
      }

      if (data.end_date) {
        const serverDate = this.getDateToServer(data.end_date).toISOString();
        params.set("end", serverDate);
      }

      if (data.executor_id) {
        params.set("user_id", data.executor_id);
      }

      return await this.get(`register/totals?${params.toString()}`);
    },
    // Загрузка файла отчёта
    async getSummaryFile(data) {
      return await this.getFile(`summary/${data.type}?start=${data.start}&end=${data.end}`);
    },
  }
}



// WEBPACK FOOTER //
// ./src/network/reports.js